import type { LayoutSchema } from '../compatibility-overrides/editor-types';

export const getGridSize = (layout: LayoutSchema) => {
  return layout.snapDirection === 'y' ? layout.gridRows : layout.gridColumns;
};
